import type { AxiosResponse } from 'axios'
import { ApiError, ErrorType } from '@/types/error'
import { isUnknownRecord } from '@/types/json'
import { cancelManager } from '@/utils/request/request-cancel'
import type { RequestConfig } from './request-config'

/** 处理响应：校验业务码，成功则返回 response.data */
export const handleResponse = (response: AxiosResponse): unknown => {
  const config = response.config as RequestConfig

  cancelManager.clearRequest(config.url || '', config.method || 'get', config.params || config.data)

  const { data } = response

  // 校验业务状态码 data.code（2xx 为成功）
  if (isUnknownRecord(data) && typeof data['code'] === 'number') {
    const code = data['code']
    const responseMessage = typeof data['message'] === 'string' ? data['message'] : undefined

    if (code < 200 || code >= 300) {
      throw new ApiError(
        ErrorType.BUSINESS_ERROR,
        responseMessage || '业务错误',
        response.status,
        code,
        undefined,
        data['data']
      )
    }
  }

  return data
}
